import React from "react";
import { redirectToHome } from "../common/commonFuntion";

const Breadcrumbs = ({ crumbs = [] }) => {
  // Define default action
  const handleDefaultClick = () => {
    window.location.href = "/";
  };

  return (
    <div className="col-md-12 breadcrumbs">
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb mb-2">
          {crumbs.map((crumb, index) => (
            <li
              key={index}
              className={`breadcrumb-item ${index === crumbs.length - 1 ? "active" : ""}`}
              aria-current={index === crumbs.length - 1 ? "page" : undefined}
            >
              {crumb.onClick ? (
                <button
                  onClick={() =>
                    crumb.onClick === "Default" ? redirectToHome() : crumb.onClick()
                  }
                  style={{
                    background: "none",
                    border: "none",
                    padding: 0,
                    color: "blue",
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                >
                  {crumb.label}
                </button>
              ) : (
                crumb.label
              )}
            </li>
          ))}
        </ol>
      </nav>
    </div>
  );
};

export default Breadcrumbs;

